<template>
  <div id="app" :class="{ 'test-env': isTestEnv }">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
import { type } from '@/store/index'

export default {
  name: 'app',
  computed: {
    isTestEnv() {
      return type === 1
    }
  }
}
</script>

<style>
</style>
